import { addOnReize, removeOnResize } from './events/resize';

export default {
	addOnReize,
	removeOnResize,
};
